// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"92eec1e1","453":"e64dcc3e"}[chunkId] + ".chunk.js";
};